export const environment = {
    production: false,
    clientId: 'be06ffb5-beec-4da2-a92f-63ac0917aac1',
    authority: 'https://login.microsoftonline.com/f3211d0e-125b-42c3-86db-322b19a65a22/',
    apiScopes: ['api://4228213e-a48f-4f81-950a-58d623a2e301/user_impersonation'],
    apiBaseUrl: 'https://dev.apigat.accenture.com',
    sentryDsn: 'https://0d8c4e1d02764c888cc9a502680f47c9@tnv-sentry.umlaut-cloud.com/14',
    version: '1.0.16'
  };
  